import { HTTP } from "./http";

export const CategoriaService = {
  getAll() {
    return HTTP.get(`categoria`);
  },
};
